export interface ChatScrollSelectors {
  messageContainer: string;
  userQuestion: string;
}

export const MOBILE_CHAT_SCROLL: ChatScrollSelectors = {
  messageContainer: '.mobile-message-container',
  userQuestion: '.mobile-user-question',
};

export const DESKTOP_CHAT_SCROLL: ChatScrollSelectors = {
  messageContainer: '.message-container',
  userQuestion: '.user-question',
};

/**
 * Scroll once so the latest user question sits near the top of the chat viewport.
 * Does not follow streaming content — the user scrolls freely while the answer grows.
 */
export function scrollLatestUserQuestionIntoView(
  scrollContainer: HTMLElement,
  selectors: ChatScrollSelectors,
  topPadding = 16
): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const containers = scrollContainer.querySelectorAll(selectors.messageContainer);
      for (let i = containers.length - 1; i >= 0; i--) {
        const container = containers[i] as HTMLElement;
        if (!container.querySelector(selectors.userQuestion)) {
          continue;
        }
        const containerRect = scrollContainer.getBoundingClientRect();
        const messageRect = container.getBoundingClientRect();
        const relativeTop = messageRect.top - containerRect.top + scrollContainer.scrollTop;
        scrollContainer.scrollTop = Math.max(0, relativeTop - topPadding);
        return;
      }
    });
  });
}

export const TABLET_CHAT_SCROLL: ChatScrollSelectors = {
  messageContainer: '.tablet-message-container',
  userQuestion: '.tablet-user-question',
};

export const CHAT_EXCHANGE_STARTED_EVENT = 'chat-exchange-started';

export function dispatchChatExchangeStarted(): void {
  window.dispatchEvent(new CustomEvent(CHAT_EXCHANGE_STARTED_EVENT));
}
